import React from "react";
import Hero from "./Hero";
import RaiseTicket from "./RaiseTicket";


function SupportPage() {
  return (
    <>
      <Hero />
      <RaiseTicket />
    </>
  );
}

export default SupportPage;
